const RequestKind = {
    PING: "PING",
    GENERATE: "GENERATE",
    REGEN: "REGEN",
    FILTER: "FILTER",
    VOTE: "VOTE",
    MARK_SEEN: "MARK_SEEN",
    DOMAINS: "DOMAINS",

    PRE_PURCHASE_INFO: "PRE_PURCHASE_INFO",
    PAYMENT_INTENT: "PAYMENT_INTENT",
    PREPARE_FOR_MONEY: "PREPARE_FOR_MONEY",
    TXN_STATUS: "TXN_STATUS",
};

export default Object.freeze(RequestKind);